<app-accordion-item 
    *ngFor="let item of data" 
    [id]="item.id" 
    [title]="item.title" 
    [content]="item.content"
    [active]="active"
    [toggleActive]="toggle">
</app-accordion-item>